import { Controller } from "@hotwired/stimulus"

// 「年齢のみを記録」は個人情報を記録する場合のみ指定できる設定なので、個人情報記録の
// 選択に連動させる。「記録しない」のときは「いいえ」に戻して選択不可にする。
export default class extends Controller {
  static targets = ["recordPersonalInformation", "option", "falseOption"]

  connect() {
    this.toggle()
  }

  toggle() {
    if (this.recordingPersonalInformation) {
      this.enableOptions()
    } else {
      this.resetToFalse()
      this.disableOptions()
    }
  }

  get recordingPersonalInformation() {
    return this.recordPersonalInformationTargets.some((radio) => radio.checked && radio.value === "1")
  }

  enableOptions() {
    this.optionTargets.forEach((radio) => { radio.disabled = false })
  }

  resetToFalse() {
    this.falseOptionTarget.checked = true
  }

  disableOptions() {
    this.optionTargets.forEach((radio) => { radio.disabled = true })
  }
}
